import * as actionType from "../actions/actionsType";

const initialState = {
  SortData: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SORT_DATA:
      return {
        ...state,
        SortData: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
